module.exports = __webpack_public_path__ + "img/awards_trophy3.bfd4f5aa.png";